import { AsteriskNotification } from "Components/AsteriskNotification";
import { BulmaNavButtons } from "Components/BulmaNavButtons";
import { useDocumentTitle } from "Components/Hooks";
import { Horizontal } from "Components/Horizontal";
import { Section } from "Components/Section";
import { WhatIsThisModal } from "Components/WhatIsThisModal";
import * as DateFns from "date-fns";
import { dateFormat, DateInput } from "Inputs/DateInput";
import { VerticalRadio } from "Inputs/Radio";
import { Program } from "SharedConstants";
import { FitnessInstructorCoverageInformationModel } from "SharedConstants/Schema";
import { Heading } from "../../Components/Heading";
import { MVCForm, MVCFormServerProps } from "../MVCForm";
import { ModelStateValues } from "../Tools";

export function CoverageInformation(
  props: FitnessInstructorCoverageInformationModel & {
    formProps: MVCFormServerProps;
  },
) {
  const getInitialValues = (values: ModelStateValues) => {
    return {
      ...values,
      EffectiveDate:
        values.EffectiveDate ||
        DateFns.format(
          DateFns.max([new Date(), new Date(props.FirstAllowedCoverageDate)]),
          dateFormat,
        ),
    };
  };

  const title = "Coverage Information";
  useDocumentTitle(`${title} - ${props.TitleProps.PageTitleSuffix}`);
  return (
    <>
      <Heading {...props} title={title} />
      <MVCForm
        {...props.formProps}
        initialValues={getInitialValues(props.formProps.initialValues)}
      >
        {({ isSubmitting }) => (
          <div>
            <AsteriskNotification />
            <Horizontal
              isRequired
              label={
                <>
                  Effective Date{" "}
                  <WhatIsThisModal modalTitle="Coverage Period">
                    {props.Program === Program.Sup
                      ? "Stand Up Paddle Instructor"
                      : "Personal Trainer"}{" "}
                    insurance policy period is one year.
                  </WhatIsThisModal>
                </>
              }
            >
              <DateInput
                fieldName="EffectiveDate"
                earliestDate={new Date(props.FirstAllowedCoverageDate)}
                latestDate={new Date(props.LastAllowedCoverageDate)}
                isReadonly={props.IsDateInputReadonly}
              />
            </Horizontal>
            <br />
            <Section
              title="Liability Limit"
              subtitle={
                <div className="is-italic">
                  <div>({props.IsAccredited ? "" : "Non-"}Accredited Rate)</div>
                  {props.IsSupiaMember && (
                    <div>(SUPIA Membership Discount)</div>
                  )}
                </div>
              }
            >
              <div style={{ display: "flex", justifyContent: "center" }}>
                <VerticalRadio
                  fieldName="AggregateIncreaseRateID"
                  options={props.AvailableAggregateIncreases.map(e => [
                    e.ID.toString(),
                    <>
                      <div>{e.Description}:</div>
                      <div>
                        Cost: <strong>{e.Rate}</strong>
                      </div>
                    </>,
                  ])}
                  hasBorderedArea
                />
              </div>
            </Section>
            <BulmaNavButtons
              backCaption="Back"
              continueCaption="Continue"
              isDisabled={isSubmitting}
            />
          </div>
        )}
      </MVCForm>
    </>
  );
}
